<div class="grid-container" #container>
  <ng-content></ng-content>
</div>
